import { useTranslation } from "react-i18next";
import pseudofruto from "../../../assets/pseudofruto.png";

export default function CuriosidadeCastanha() {
  const { t } = useTranslation();

  return (
    <section id="curiosidade-castanha" className="curiosidade">
      <h1>{t("nos.curiosidade.titulo")}</h1>
      <div className="curiosidade-container">
        <img src={pseudofruto} alt="Imagem do pseudofruto" />
        <p>{t("castanha.historia.descricao.p3")}</p>
      </div>
    </section>
  );
}
